/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-duplicates */
import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { format, parseISO } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { Container, Button, Row, Col } from 'react-bootstrap';

import {
  FaComment,
  FaPenAlt,
  FaArrowUp,
  FaArrowDown,
  FaWhatsapp,
  FaEnvelope,
  FaSpinner,
} from 'react-icons/fa';
import api from '../../../services/api';

import { formatPrice, htmlDecode, TIPO_USUARIO } from '../../../utils/funcoes';

import { useToast } from '../../../hooks/toast';
import { useAuth } from '../../../hooks/auth';
import { useClinica } from '../../../hooks/clinica';

import Input from '../../../components/Input';
import Select from '../../../components/Select';
import Loading from '../../../components/Loading';

import getValidationErrors from '../../../utils/getValidationErrors';

import { RelatorioHeader } from './styles';
import Modal from '../../../components/Modal';
// import Mensagem, { IDadosMensagem } from './Mensagem';
import Paginacao from '../../../components/Paginacao';
import Cadastro from './Cadastro';
import getResponseErrors from '../../../utils/getResponseErrors';
import { Spinner } from '../../../components/Agendamento/styles';
import HeaderSimples from '../components/HeaderSimples';

export interface IAtrasados {
  PlaCodigo: number;
  PlaClinica: number;
  PacCodigo: string;
  PlaNomeResp?: string;
  PacNome: string;
  PlaTelefoneResp?: string;
  Tel: string;
  Vencidas: string;
  TotalVencidas: number;
  Total: number;
  Dias: number;
  Codigo: string;
  Aviso: number;
  Cobranca: string;
  CobDataAviso: string;
  CobMotCodigo: number;
  PlaRenovado: string;
  TotalFormatado: string;
  soExibe?: boolean;
}

interface IFormBusca {
  TxtData: Date;
  paciente: string;
  CboTipo: number;
  order: string;
  nParcelaInicio?: string;
  nParcelaFim?: string;
  PlaClinica: string;
}

interface IDataExibe {
  dataHora: string;
  dataDiaSemana: string;
}

export interface IPaginacao {
  termoBusca: IFormBusca;
  limite: number;
  pagina: number;
}

export interface ICadastroCobranca {
  plaCodigo: number;
  codigo: string;
}

const Cobranca: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.ATENDENTE_CAIXA) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const { addToast } = useToast();
  const { optionsClinica } = useClinica();

  const formRefBusca = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const [loadingTextoMensagem, setLoadingTextoMensagem] = useState(false);
  const [showModalMensagem, setShowModalMensagem] = useState(false);
  const [showModalCadastro, setShowModalCadastro] = useState(false);
  const [dadosAtrasados, setDadosAtrasados] = useState<IAtrasados[]>([]);
  const [selecionado, setSelecionado] = useState<ICadastroCobranca | undefined>(
    undefined,
  );
  const [mensagemCobranca, setMensagemCobranca] = useState<string>();
  const [paginacao, setPaginacao] = useState<IPaginacao | undefined>(undefined);
  const [totalRegistros, setTotalRegistros] = useState<number | undefined>(
    undefined,
  );
  const initialData = {
    TxtData: format(new Date(), 'yyyy-MM-dd'),
    paciente: '',
    status: 1,
    nParcelaInicio: '1',
    nParcelaFim: '12',
    PlaClinica: '0',
  };
  const [dataExibe, setDataExibe] = useState<IDataExibe>();
  const [orderAsc, setOrderAsc] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    async function buscaAtrasados(): Promise<void> {
      if (paginacao) {
        try {
          setLoading(true);
          const {
            CboTipo,
            order,
            paciente,
            nParcelaFim,
            nParcelaInicio,
            PlaClinica,
          } = paginacao.termoBusca;
          const ordenacao = order === '' ? '' : `&order=${order}`;
          const nomePaciente = paciente === '' ? '' : `&paciente=${paciente}`;
          const parcelaInicio =
            !nParcelaInicio || nParcelaInicio === ''
              ? ''
              : `&parcelaInicio=${nParcelaInicio}`;
          const parcelaFim =
            !nParcelaFim || nParcelaFim === ''
              ? ''
              : `&parcelaFim=${nParcelaFim}`;
          const placlinica = PlaClinica === '0' ? '' : `&clinica=${PlaClinica}`;

          const response = await api.get<{
            count: number;
            atrasados: IAtrasados[];
          }>(
            `/cobranca/atrasados?status=${CboTipo}${ordenacao}${nomePaciente}${parcelaInicio}${parcelaFim}${placlinica}&pagina=${paginacao.pagina}&limite=${paginacao.limite}`,
          );

          setTotalRegistros(
            response.data.count === 0 ? undefined : response.data.count,
          );

          const dadosFormatados: IAtrasados[] = response.data.atrasados.map(
            item => {
              return {
                ...item,
                TotalFormatado: formatPrice(Number(item.Total)),
                PlaNomeResp: item.PlaNomeResp
                  ? `Responsável: ${item.PlaNomeResp}`
                  : '',
              };
            },
          );

          setDadosAtrasados(dadosFormatados);
        } catch (error) {
          const mensagem = getResponseErrors(error);
          addToast({
            type: 'error',
            title: 'Não foi possível carregar dados de cobrança',
            description: mensagem,
          });
        } finally {
          setLoading(false);
        }
      }
    }
    if (paginacao) buscaAtrasados();
  }, [paginacao, addToast]);

  const handleSubmitBusca = useCallback(async (dados: IFormBusca) => {
    try {
      formRefBusca.current?.setErrors({});
      const schema = Yup.object().shape({
        TxtData: Yup.date().required(),
        CboTipo: Yup.number().required(),
      });

      await schema.validate(dados, {
        abortEarly: false,
      });

      const dataSelecionada = parseISO(dados.TxtData.toString());

      // const dataFormatada = format(dataSelecionada, 'yyyy-MM-dd');

      setDataExibe({
        dataDiaSemana: format(dataSelecionada, 'dd/MM/yyyy EEEE', {
          locale: ptBR,
        }).toUpperCase(),
        dataHora: format(new Date(), 'dd/MM/yyyy HH:mm'),
      });

      setPaginacao({
        termoBusca: {
          CboTipo: dados.CboTipo,
          paciente: dados.paciente,
          TxtData: dados.TxtData,
          order: '',
          nParcelaFim: dados.nParcelaFim,
          nParcelaInicio: dados.nParcelaInicio,
          PlaClinica: dados.PlaClinica,
        },
        pagina: 1,
        limite: 300,
      });
      setOrderAsc(undefined);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      }
    }
  }, []);

  const handleOrder = useCallback((value: boolean) => {
    setOrderAsc(value);
    setPaginacao(state => {
      return (
        state && {
          ...state,
          pagina: 1,
          termoBusca: { ...state.termoBusca, order: value ? 'ASC' : 'DESC' },
        }
      );
    });
  }, []);

  // const handleMensagem = useCallback(
  //   (atrasado: IAtrasados) => {
  //     const {
  //       Dias: dias,
  //       PacNome: pacNome,
  //       TotalFormatado: totalFormatado,
  //       Vencidas: vencidas,
  //     } = atrasado;
  //     const dadosMensagem: IDadosMensagem = {
  //       dias,
  //       pacNome,
  //       totalFormatado,
  //       vencidas,
  //       clinica: {
  //         nome: '',
  //         tel: '',
  //       },
  //       nomeClinica,
  //     };
  //     setMensagemCobranca(dadosMensagem);
  //     setShowModalMensagem(true);
  //   },
  //   [nomeClinica],
  // );

  const handleCadastro = useCallback((plaCodigo: number, codigo: string) => {
    setSelecionado({ plaCodigo, codigo });
    setShowModalCadastro(true);
  }, []);

  const handleFecharModal = useCallback(() => {
    setMensagemCobranca(undefined);
    setShowModalMensagem(false);
  }, []);
  const handleFecharModalCadastro = useCallback(() => {
    setShowModalCadastro(false);
  }, []);

  const handleProximaPagina = useCallback((page: number) => {
    setPaginacao(state => {
      return state && { ...state, pagina: page };
    });
  }, []);

  const handleAtualizaCobranca = useCallback((plaCodigo: number) => {
    setDadosAtrasados(state => {
      const atrasados = state.filter(item => item.PlaCodigo !== plaCodigo);

      return atrasados;
    });
    setSelecionado(undefined);
    setShowModalCadastro(false);
  }, []);

  const handleEnviaConfirmacao = useCallback(
    async (dados: IAtrasados) => {
      try {
        setLoadingTextoMensagem(true);
        const { TotalFormatado, soExibe, ...rest } = dados;

        let { PacCodigo } = rest;
        let { PacNome } = rest;

        const telefone = dados.PlaTelefoneResp
          ? dados.PlaTelefoneResp.split(' ')[0] || ''
          : dados.Tel?.split(' ')[0] || '';

        if (rest.PlaNomeResp) {
          const codigoNome = rest.PlaNomeResp?.split(' - ');
          [PacCodigo, PacNome] = codigoNome;
        }

        const response = await api.post(`/cobranca/textocobranca`, {
          ...rest,
          PacCodigo,
          PacNome,
          Tel: telefone,
          SoMensagem: soExibe,
        });

        if (response.data.includes('Mensagem não enviada')) {
          addToast({
            title: 'Não foi possível Enviar mensagem',
            type: 'error',
            description: 'Mensagem não enviada',
          });

          return;
        }
        if (response.data.includes('Mensagem enviada com sucesso')) {
          addToast({
            title: 'Mensagem enviada com sucesso',
            type: 'success',
            description: 'Mensagem enviada com sucesso',
          });

          return;
        }

        const textoDecode = htmlDecode(response.data);
        const textoMensagem = encodeURIComponent(textoDecode);

        if (soExibe) {
          setMensagemCobranca(textoDecode.replace(/\n/g, '<br />'));
          setShowModalMensagem(true);
        }

        if (!soExibe) {
          const linkWhatsapp = `https://api.whatsapp.com/send?phone=55${telefone}&text=${textoMensagem}`;
          window.open(linkWhatsapp, '_blank');
        }
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível salvar a notificação',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoadingTextoMensagem(false);
      }
    },
    [addToast],
  );

  return (
    <>
      {showModalMensagem && mensagemCobranca && (
        <Modal
          show={showModalMensagem}
          titulo="Mensagem de Cobrança"
          handleFecharModal={handleFecharModal}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: mensagemCobranca,
            }}
          />
          {/* <Mensagem dados={mensagemCobranca} /> */}
        </Modal>
      )}
      {showModalCadastro && selecionado && (
        <Modal
          show={showModalCadastro}
          titulo="Registro de Cobrança"
          handleFecharModal={handleFecharModalCadastro}
        >
          <Cadastro
            dadosCobranca={selecionado}
            handleFechar={handleAtualizaCobranca}
          />
        </Modal>
      )}

      <Container fluid className="mt-2">
        {loading && <Loading />}
        <>
          <div className="d-print-none bg-white border p-2 mb-2">
            <div className="p-2 mb-2">
              <h2 id="topoBusca">Relatório de Cobranças</h2>
            </div>

            <Form
              ref={formRefBusca}
              initialData={initialData}
              onSubmit={handleSubmitBusca}
            >
              <Row>
                <Col md={2}>
                  <Input name="TxtData" label="Data" type="date" required />
                </Col>
                <Col md={4}>
                  <Input name="paciente" label="paciente" type="text" />
                </Col>
                <Col md={3}>
                  <Select
                    name="CboTipo"
                    label="Status"
                    options={[
                      { label: 'Em Cobrança', value: '1' },
                      { label: 'Enviados ADM', value: '2' },
                      { label: 'Cancelar', value: '3' },
                    ]}
                  />
                </Col>

                <Col md={2}>
                  <br />
                  <Button type="submit" size="sm" variant="outline-secondary">
                    BUSCAR
                  </Button>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={2}>
                  <Select
                    name="nParcelaInicio"
                    label="Parcela de:"
                    options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(it => {
                      return { label: it.toString(), value: it.toString() };
                    })}
                  />
                </Col>
                <Col md={2}>
                  <Select
                    name="nParcelaFim"
                    label="até:"
                    options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(it => {
                      return { label: it.toString(), value: it.toString() };
                    })}
                  />
                </Col>
                <Col md={4}>
                  <Select
                    name="PlaClinica"
                    label="Clinica"
                    options={[
                      { value: '0', label: 'TODAS' },
                      ...optionsClinica,
                    ]}
                  />
                </Col>
              </Row>
            </Form>
          </div>

          <div className="bg-white border p-2 my-3">
            <HeaderSimples dataImpressao={dataExibe?.dataHora} />
          </div>

          <RelatorioHeader>
            CARTÕES ATRASADOS - {dataExibe?.dataDiaSemana}
          </RelatorioHeader>
          <div className="bg-white border p-2">
            {dadosAtrasados && dadosAtrasados.length > 0 && (
              <>
                <div
                  className="d-flex align-self-sm-center"
                  style={{ justifyContent: 'center', height: '25px' }}
                >
                  <span>
                    <b>
                      Vencidos:
                      {totalRegistros}
                    </b>
                  </span>
                </div>
                <table
                  className="table table-hover table-sm table-font-small"
                  style={{ fontFamily: 'verdana' }}
                >
                  <thead>
                    <tr className="text-left">
                      <th>Paciente</th>
                      <th style={{ width: '180px' }}>Telefone</th>
                      {/* <th style={{ width: '80px' }}>Dias</th> */}
                      <th style={{ width: '80px' }}>
                        <span
                          style={{
                            padding: '0',
                            lineHeight: '0',
                            fontWeight: 'bold',
                            fontSize: 'Small',
                          }}
                        >
                          Dias{` `}
                        </span>
                        <span
                          className="btn"
                          style={{
                            padding: '0',
                            lineHeight: '0',
                            fontWeight: 'bold',
                            fontSize: 'Small',
                          }}
                        >
                          {orderAsc ? (
                            <FaArrowUp onClick={() => handleOrder(false)} />
                          ) : (
                            <FaArrowDown onClick={() => handleOrder(true)} />
                          )}
                        </span>
                      </th>
                      <th>Vencidas</th>
                      <th>Total</th>
                      <th>Aviso</th>
                      <th>&nbsp;</th>
                      <th style={{ width: '40px' }}>&nbsp;</th>
                      <th style={{ width: '40px' }}>&nbsp;</th>
                      <th style={{ width: '40px' }}>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dadosAtrasados &&
                      dadosAtrasados.map(item => (
                        <tr
                          key={`atrasado-${item.PlaCodigo}`}
                          style={{ height: '30px' }}
                          title={`${item.PlaCodigo}`}
                          className="small"
                        >
                          <td>
                            <span>
                              {item.PacNome} <b>{item.PlaNomeResp}</b>
                            </span>
                          </td>
                          <td>{item.Tel}</td>
                          <td>{item.Dias}</td>
                          <td>{item.Vencidas}</td>
                          <td>{item.TotalFormatado}</td>
                          <td
                            className={`${
                              item.Aviso > 0 ? 'text-info' : 'text-danger'
                            }`}
                            style={{ textAlign: 'center' }}
                          >
                            <FaComment
                              title={`${item.Cobranca} - ${item.Aviso}`}
                              fontSize={15}
                            />
                          </td>
                          <td>
                            {item.PlaRenovado === '1' ? (
                              <span
                                className="badge badge-sucess"
                                style={{ padding: '0 4px!important' }}
                              >
                                R
                              </span>
                            ) : (
                              ' '
                            )}
                          </td>
                          <td>
                            <Button
                              variant="info"
                              title={`${item.PlaCodigo}:${item.Codigo}`}
                              onClick={
                                () =>
                                  handleCadastro(item.PlaCodigo, item.Codigo)
                                // eslint-disable-next-line react/jsx-curly-newline
                              }
                            >
                              <FaPenAlt fontSize="14" />
                            </Button>
                          </td>
                          <td>
                            <Button
                              variant="info"
                              onClick={
                                () =>
                                  handleEnviaConfirmacao({
                                    ...item,
                                    soExibe: true,
                                  })
                                // eslint-disable-next-line react/jsx-curly-newline
                              }
                            >
                              {loadingTextoMensagem ? (
                                <Spinner>
                                  <FaSpinner fontSize="14" />
                                </Spinner>
                              ) : (
                                <FaEnvelope fontSize="14" />
                              )}
                            </Button>
                          </td>
                          <td>
                            <Button
                              type="button"
                              variant="success"
                              onClick={() => handleEnviaConfirmacao(item)}
                            >
                              <FaWhatsapp fontSize="16" />
                            </Button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <Paginacao
                  limitePagina={paginacao?.limite || 50}
                  paginasVizinhas={2}
                  totalRegistros={totalRegistros}
                  paginaInicio={paginacao?.pagina}
                  handleProximaPagina={handleProximaPagina}
                />
              </>
            )}
          </div>
        </>
      </Container>
    </>
  );
};

export default Cobranca;
